import Vue from 'vue'
import Router from 'vue-router'
import FrontPage from '@/components/FrontPage'
import MatchedSession from '@/components/MatchedSession'
import PersonalCenter from '@/components/PersonalCenter'
import Settings from '@/components/Settings'
import Channels from '@/components/Channels'
import ChannelDetail from '@/components/ChannelDetail'
import ChannelCreate from '@/components/ChannelCreate'
import ChannelSearchSessions from '@/components/ChannelSearchSessions'
import ChannelHistoryChats from '@/components/ChannelHistoryChats'
import ChannelMatchHistory from '@/components/ChannelMatchHistory'
import ChannelMembers from '@/components/ChannelMembers'
import store from '@/store'
import common from '@/assets/common.js'

import axios from 'axios'
Vue.use(Router)

// const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

// import * as ww from '@wecom/jssdk'
var ww = require('@wecom/jssdk')
console.log(ww.SDK_VERSION)

var router = new Router({
  base: '/app/',
  routes: [
    {
      // 独立 AI 对话已改为全局弹窗（AiChatPopup，经 store.showAiChatPopup 控制），
      // /ai 路由废弃，旧链接回落到首页
      path: '/ai',
      redirect: '/channels'
    },
    {
      path: '/',
      redirect: '/channels'
    },
    {
      path: '/matches',
      name: 'Matches',
      component: () => import('../components/Connections.vue')
    },
    {
      path: '/messages',
      name: 'Messages',
      component: () => import('../components/Contacts.vue')
    },
    {
      path: '/matched-session',
      name: 'MatchedSession',
      component: MatchedSession
    },
    {
      path: '/personal-center',
      name: 'PersonalCenter',
      component: PersonalCenter
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/blocked-users',
      name: 'BlockedUsers',
      component: () => import('../components/BlockedUsers.vue')
    },
    {
      path: '/channels',
      name: 'Channels',
      component: Channels
    },
    {
      path: '/channel/:id',
      name: 'ChannelDetail',
      component: ChannelDetail
    },
    {
      path: '/channel-create',
      name: 'ChannelCreate',
      component: ChannelCreate
    },
    {
      path: '/channel-search/:id',
      name: 'ChannelSearchSessions',
      component: ChannelSearchSessions
    },
    {
      path: '/channel-history/:id',
      name: 'ChannelHistoryChats',
      component: ChannelHistoryChats
    },
    {
      path: '/channel-match-history/:id',
      name: 'ChannelMatchHistory',
      component: ChannelMatchHistory
    },
    {
      path: '/channel-members/:id',
      name: 'ChannelMembers',
      component: ChannelMembers
    }
  ]
})

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

router.beforeEach(async (to, from, next) => {
  var region = router.app.$config && router.app.$config.region
  var isCnRegion = region === 'cn'

  // 隐私、条款、安全标准页面：CN 和 Global 都可访问，不需要登录
  // 注：这些页面已改为独立静态页（/privacy, /terms, /safety），不再走 SPA 路由

  // CN 和 Global region: FrontPage 及其他交互页面，需要完整的登录、初始化流程
  router.app.$root.$common.setNotLoginHandler()
  var endpointId = router.app.$cookies.get('endpoint-id')
  if (!endpointId) {
    endpointId = Math.floor(Math.random() * (9999999999 - 1000000000) + 1000000000)
    router.app.$cookies.set('endpoint-id', endpointId, 60 * 60 * 24 * 365 * 100)
  }
  setVersionHeader(router.app.$config.version)
  store.state.configFetched = true
  if (router.app.$root.$common.getToken()) {
    await router.app.$root.$common.setTokenHeader()
    router.app.$root.$store.state.alreadyLogin = true
    // 每次路由切换时，拉取最新的用户信息
    if (!store.state.user || !store.state.user.userId) {
      try {
        const userId = router.app.$root.$common.getUserId()
        if (userId) {
          const userResp = await axios.post('/api/user/get_user_by_user_id', { userId })
          if (userResp.data && userResp.data.code == '0') {
            store.state.user = userResp.data.data
          }
        }
      } catch (error) {
        console.error('Failed to fetch user info:', error)
      }
    }
  }
  var url = '/api/user/init'
  var req = {
    clientType: 'browser',
    clientDetail: navigator.userAgent
  }
  var tmp = await axios.post(url, req)
  if (tmp) {
    var tmp = tmp.data
    if (tmp.code == '0') {
      var initResult = tmp.data
      // 合并后端配置到 $config，优先级高于静态配置
      Object.assign(router.app.$config, initResult)
      // 如果服务端返回了 token，说明自动创建了匿名用户，执行登录成功逻辑
      if (initResult.token) {
        var existingToken = router.app.$root.$common.getToken()
        if (!existingToken || existingToken !== initResult.token) {
          common.handleLoginSuccess(initResult)
          return
        }
      }
    }
  }
  console.log('[Config] Final config:', router.app.$config)
  router.app.$store.state.beforeEatchInitialized = true
  console.log('next called')
  next()
})

router.afterEach((to) => {
  var region = router.app.$config && router.app.$config.region
  var appTitle = region === 'cn' ? '章摇摇 - 小摇理解你，摇到对的TA' : 'OctoSay - AI that gets you, matches you.'
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - ' + appTitle
  } else {
    document.title = appTitle
  }
})

function setVersionHeader(version) {
  axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    if (version) {
      config.headers['baggage-version'] = version
    }
    return config
  }, function (error) {
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js